import { Alpine } from '../../../../../vendor/livewire/livewire/dist/livewire.esm';
import modifierValue from '../../helpers/modifierValue';
import { handleClasses } from './responsive';

Alpine.directive('responsive', (el, { expression, modifiers }, { cleanup }) => {
    const resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
            if (entry.contentRect.width > 0) {
                handleClasses(el, entry.contentRect.width, expression)
            }
        });
    });

    Alpine.nextTick(() => {
        resizeObserver.observe(getTarget());
    })

    window.addEventListener('loading', function ({ detail }) {
        const { loading } = detail

        if (loading) {
            return;
        }

        handleClasses(el, getTarget().clientWidth, expression);
    })

    cleanup(() => {
        resizeObserver.disconnect();
    })

    function getTarget() {
        const target = modifierValue(modifiers, 'target', null) ?? el.getAttribute('target');

        return document.querySelector([`[x-ref="${target}"]`]) ?? el;
    }
})
